
    import React from 'react';
    import { useQuestionaireCreate, useQuestionaireSoftDelete,useQuestionaireMultipleSoftDelete, useQuestionaireUpdate } from '../../queries/Questionaire.queries';
    import Questionaire from './Questionaire';
    
    const QuestionaireContainer = () => {
    
      const {mutate:addRecord} = useQuestionaireCreate();
      const {mutate:editRecord} = useQuestionaireUpdate();
      const {mutate:deleteRecord} = useQuestionaireSoftDelete();
      const {mutate:deleteRecords} = useQuestionaireMultipleSoftDelete();
    
      const onAddRecord = (record) => {
        return new Promise((resolve,reject) => {
          addRecord(record, {
            onSuccess: async () => resolve('Record created successfully.'),
            onError: async (error) => reject(error?.message),
          });
        })
      };
    
      const onEditRecord = (record) => {
        return new Promise((resolve, reject) => {
          editRecord(
            record,
            {
              onSuccess: async () => resolve('Record updated successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };
    
      const onDeleteRecord = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecord(
            record, 
            {
              onSuccess: async () => resolve('Record deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      const onMultiDelete = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecords(
            record, 
            {
              onSuccess: async () => resolve('Records deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      return (
        <Questionaire 
          addRecord={onAddRecord}
          deleteRecord={onDeleteRecord}
          deleteRecords={onMultiDelete}
          editRecord={onEditRecord}
        />
      )
    }
    
    export default QuestionaireContainer;
    